/*eslint-disable*/
import api from '../'

class TimetableApi {

    static forAllGrades() {
        return api.axios.get('/timetable')
            .then(response => response.data);
    }

    // GET: timetable
    static list(params, cancelToken = null) {
        return api.axios.get('/timetable', {params, cancelToken})
            .then((response) => response.data);
    }
}

export default TimetableApi;
